import { SxProps, Theme } from '@mui/material';
import theme from '@/styles/theme';

const container: SxProps<Theme> = {
  padding: theme.spacing(2),
  height: '100vh',
};

const card: SxProps<Theme> = {
  marginY: theme.spacing(3),
};

const avatar: SxProps<Theme> = {
  height: theme.sizes.avatar.lg,
  width: theme.sizes.avatar.lg,
  backgroundColor: theme.palette.primary.main,
};

const styles = {
  container,
  card,
  avatar,
};

export default styles;
